<template>
  <div>
    <v-img :src="cover" :max-width="size">
      <div v-if="hover || playing" :style="darken" class="centered">
        <v-icon v-if="!playing" size="50" @click="playSample">mdi-play</v-icon>

        <v-progress-circular
          v-if="playing"
          :value="sampleProgress"
          size="55"
          color="primary"
          rotate="270"
          class="ml-2"
        >
          <v-icon size="50" @click="pauseSample">mdi-pause</v-icon>
        </v-progress-circular>
      </div>
    </v-img>
  </div>
</template>
<script>
export default {
  name: "editTrackCover",
  props: {
    cover: String,
    sample: String,
    hover: Boolean,
    size: Number,
  },
  data() {
    return {
      playing: false,
      audio: new Audio(this.sample),
      duration: 0,
      sampleProgress: 0,
    };
  },
  computed: {
    darken: function () {
      return "background: black; opacity: 65%; height: " + this.size + "px";
    },
  },
  methods: {
    playSample: function () {
      this.playing = true;
      this.audio.play();
    },
    pauseSample: function () {
      this.playing = false;
      this.audio.pause();
    },
  },
  mounted() {
    this.audio.addEventListener("ended", () => {
      this.pauseSample();
    });
    this.audio.addEventListener("timeupdate", () => {
      this.sampleProgress = (this.audio.currentTime / this.duration) * 100;
    });
    this.audio.addEventListener("loadedmetadata", () => {
      this.duration = this.audio.duration;
    });
  },
};
</script>
<style scoped>
.centered {
  display: grid;
  place-items: center stretch;
}
</style>